import { render, staticRenderFns } from "./FbPageList.vue?vue&type=template&id=755ea3e1&"
import script from "./FbPageList.vue?vue&type=script&lang=js&"
export * from "./FbPageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports